import { Navigate, useParams } from 'react-router-dom'

/**
 * /d/:uuid/edit (또는 옛 nested URL) 호환 — 인라인 edit (`?edit=1`) 으로 redirect.
 * Editor 본체는 components/EditorPane.tsx + routes/DocumentView.tsx 의 ?edit=1 분기.
 */
export function DocumentEdit() {
  const { uuid } = useParams<{ uuid: string }>()
  if (!uuid) return <Navigate to="/groups" replace />
  return <Navigate to={`/d/${uuid}?edit=1`} replace />
}
